import axios from "axios";
import { API } from "../Common";

export default {
    /**
     * # Retrieve backend version
     *
     * For old local backends, this will run to an error because
     * the route won't exist. In that case, fall back to 'null' in the model.
     *
     * In case a response arrives, it will be like
     * ```json
     * {
     *  version: "v3.0.5"
     * }
     * ```
     */
    getServer: function (restaurantID) {
        return new Promise((resolve, reject) => {
            axios
                .get(`${API}v3/restaurants/${restaurantID}/server`)
                .then((response) => resolve(response.data))
                .catch((error) => reject(error));
        });
    }
};



// WEBPACK FOOTER //
// ./src/services/api/Server.js